const AUTHORIZATION_NOTICE_KEY = 'authorization_notice';
const UNAUTHORIZED_CURRENT_USER = 'unauthorized-current-user';

export function storeUnauthorizedCurrentUserNotice() {
  sessionStorage.setItem(AUTHORIZATION_NOTICE_KEY, UNAUTHORIZED_CURRENT_USER);
}

// Pure read with no side effect: safe to call from a useState initializer,
// which React 18 StrictMode invokes twice in development.
export function peekAuthorizationNotice() {
  return sessionStorage.getItem(AUTHORIZATION_NOTICE_KEY);
}

// Idempotent delete: safe to call from a useEffect, which StrictMode also
// double-invokes, but removing an already-removed key is a no-op.
export function clearAuthorizationNotice() {
  sessionStorage.removeItem(AUTHORIZATION_NOTICE_KEY);
}

export { UNAUTHORIZED_CURRENT_USER };
